import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutShiftService {
  public readonly containsSystemNotification: WritableSignal<boolean> =
    signal(false);
}
